import * as React from "react";
import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <>
    <rect x="2" y="2" width="20" height="20" rx="4" />
    <path
      className="Checkbox-over"
      opacity="0"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 0C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6C0 2.68629 2.68629 0 6 0H18ZM6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6Z"
    />
    <path
      d="M15.2801 8.73785C15.5972 8.42072 16.1114 8.42072 16.4285 8.73785C16.7168 9.02615 16.743 9.47729 16.5071 9.7952L16.4285 9.88628L11.2897 15.025C11.0015 15.3133 10.5504 15.3395 10.2325 15.1037L10.1414 15.0252L7.57098 12.4558C7.25378 12.1387 7.25367 11.6245 7.57074 11.3073C7.85898 11.019 8.31011 10.9927 8.62807 11.2285L8.71917 11.3071L10.7146 13.3018L15.2801 8.73785Z"
      fill="white"
    />
    <path
      className="Checkbox-focus"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 0C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6C0 2.68629 2.68629 0 6 0H18ZM6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6Z"
    />
  </>,
  "AcUnit"
);
